import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage"; // Import Firebase Storage

// Your Firebase config object (replace with your actual config)
const firebaseConfig = {
   apiKey: "AIzaSyClJKZl6WdSnHIMWRkQS32Xw5_9_lthJCE",
   authDomain: "explore2teach-113c9.firebaseapp.com",
   projectId: "explore2teach-113c9",
   storageBucket: "explore2teach-113c9.firebasestorage.app",
   messagingSenderId: "724990568294",
   appId: "1:724990568294:web:a391aaf51cf185e63d0aa7",
   measurementId: "G-60GHNQY0PY"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);
const analytics = getAnalytics(firebaseApp);
const storage = getStorage(firebaseApp); // Initialize Firebase Storage

export { firebaseApp, auth, firestore, analytics,storage };
